export default __webpack_public_path__ + "static/media/discover.c3af7543.png";